import router from './router'
import store from './store'
import { getToken, setUserInfo, removeToken, removeRefreshToken } from '@/util/auth'
import * as authUtils from '@/util/auth'
import * as lib from '@/util/lib.js'
import { getRefreshToken } from '@/api/login'
import translate from '@/util/errorCode'
import Notify from '@/plugins/notify'
import {getLanguageStr} from '@/util/language.js'
import {mapGetters} from 'vuex'

const whiteList = ['/login'] // 不重定向白名单

function actionRole (roleId, next) {
  store.dispatch('user/GetRoles', { 'type': 'GET_USER_ROLES', roleId }).then(response => {
    let perms = localStorage.getItem('rolePermissions')
    if (!perms) {
      localStorage.setItem('rolePermissions', JSON.stringify(response))
      location.reload()
    } else if (JSON.stringify(response) !== perms) {
      localStorage.setItem('rolePermissions', JSON.stringify(response))
      next('/login')
    }
    // let isLogin = JSON.stringify(response) === localStorage.getItem('rolePermissions')
    // if(!isLogin) {
    // 	// 跳转到平安的登录
    // 	next("/login")
    // }
  }, error => this.$notify(error))
}
function actionFunction (functionId, next) {
  store.dispatch('user/GetFunctions', { 'type': 'GET_USER_FUNCTIONS', functionId }).then(response => {
    let perms = localStorage.getItem('buttonPermissions')
    if (!perms) {
      localStorage.setItem('buttonPermissions', JSON.stringify(response))
      next(getLoginToRouteByAuth(response))
    } else if (JSON.stringify(response) !== perms) {
      localStorage.setItem('buttonPermissions', JSON.stringify(response))
      next('/login')
    }
    // let isLogin = JSON.stringify(response) === localStorage.getItem('buttonPermissions')
    // if(!isLogin) {
    // 	// 跳转到平安的登录
    // 	next("/login")
    // }
  }, error => this.$notify(error))
}
function getLoginToRouteByAuth (auth) {
  let arr = routesDic.allRoutes.map(r => r.code)
  let result = []
  arr.forEach(element => {
    if (auth.includes(element)) {
      result.push(element)
      // let partRole=[];
      // $.each(this.userInfo.organization.businessType.split(","),function(){
      // 	switch(this){
      // 		case "1":partRole.push("A");break;
      // 		case "2":partRole.push("B");break;
      // 	}
      // });
      // if(partRole.includes(element.split("/")[0])){
      // 	result.push(element)
      // }
    }
  })
  // return result

  // let res = this.getLoginToRouteByAuth(response)
  if (result.length) {
    let path = routesDic.allRoutes.find(r => r.code === result[0])['route']
    // 重定向path save
    window.localStorage.setItem('directPath', path)
    // this.$router.push( path )
    return path
  } else {
    // this.$router.push('/noPermission')
    return stage.loc.loginSystem.um ? '/login' : '/noPermission'
  }
}
function canTo (to, from, next) { // 判断是否有条件前往
  let path = to.path.split('/')[1]
  if ('/maintain/device'.includes(path)) {
    let pass = false, part = ''
    let partRole = store.getters['user/userInfo'].organization.businessType
    switch (path) { // 除了判断权限，还要判断板块是否开放
      case 'maintain':
        part = i18n.t('fill3rd135', [getLanguageStr('word1184'), '运维板块'])
        pass = lib.doPermissions('A')// &&partRole.indexOf(1)!==-1
        break
      case 'device':
        part = getLanguageStr('word1810', '设备板块')
        pass = lib.doPermissions('B')// &&partRole.indexOf(2)!==-1
        break
    }
    if (pass) {
      next()
    } else {
      Notify.init(i18n.t('fill3rd45', [part, '你没有{0}权限，无法执行跳转']))
      if (from.path == '/') next(from.path)
    }
  } else next()
  if (to.query && to.path == from.path) {
    location.reload()
  }
}

let delayTo
router.beforeEach((to, from, next) => {
  lib.updateToDo('router')

  if (from.path != '/' && to.path.split('/')[1] == stage.loc.baseRouter.split('/')[1]) {
    to.path = stage.loc.baseRouter + to.path.substr(1)
  }
  clearTimeout(delayTo)
  if (to.redirectedFrom && to.redirectedFrom.indexOf('html/privacy') >= 0) { // 外部调用服务协议页面纠正
    let file = to.redirectedFrom.split('/')
    file = file[file.length - 1]
    location.replace('//' + location.host + '/static/oem/CSICloud/privacy/' + file)
    // next("/static/oem/CSICloud/privacy/"+file);
    // location.href="//"+location.host+"/static/oem/CSICloud/privacy/"+file;
  }
  // else if(to.redirectedFrom&&to.redirectedFrom.indexOf("oem/")>=0){//允许访问oem路径下所有资源，并进行适当的转换
  // 	let newPath=to.redirectedFrom.replace("oem/","");
  // 	location.replace("//"+location.host+"/static/oem/"+stage.loc.customer+newPath);
  // }
  // else{
  // 	$.each(stage.setting.loc.replaceUrl,function(){
  // 		if(this.from.indexOf(to.redirectedFrom)>=0) location.replace("//"+location.host+this.to);
  // 	});
  // }
  delayTo = setTimeout(() => { // 3秒未到目标路由，进行刷新页面，避免缓存问题
    if ((stage.loc.baseRouter + to.path).replace(/\//g, '') != location.pathname.replace(/\//g, '')) {
      trace('疑似页面缓存，重刷页面')
      location.reload()
    }
  }, 1000 * 5)
  /*
		to: 路由即将跳到哪
		from: 从哪个路由来
		next(): 不破坏路由跳转，按照之前的路由正常跳转
		next('/path'): 破坏原来的跳转，跳到新的路由
	 */
  if (to.path.indexOf("/tool")===0) next()
  // else if(stage.type.c&&!lib.getCookie("type")&&["/platformSelect","/"].indexOf(to.path)<0){//二合一判断，没有通过选择进入，回到选择页面，配合nginx取cookie运作
  // 	trace(["/platformSelect","/"].indexOf(to.path));next("/");
  // }
  else if ('/login/reg/noPermission/rePassword/platformSelect/static'.includes(to.path.split('/')[1])) next()
  else {
    if (stage.loc.loginSystem.um) { // 开启平安um 模式
      // 刷新导致缺失
      if (to.path.indexOf('/sim') == -1 && store.getters['user/userRoles'].length === 0) {
        // 获取userInfo 每次刷新都会走
        // authUtils.clearUserData();
        store.dispatch('user/getInfo').then(response => {
          stage.time.timeZoneCode = response.organization.timezone
          stage.time.timeZone = mz.tz(response.organization.timezone).format('Z') // 时区转成可读小时分
          stage.time.offset = mz.tz(response.organization.timezone)._offset * 60 * 1000 // 时区转成毫秒
          let { orgUser: { functionId, roleId } } = response
          actionRole(roleId, next)
          actionFunction(functionId, next)
          next()
        }, error => {
          let { status } = error.response
          if (status === 401) {
            // 失败的话重新跳转到平安的登录
            next('/login')
          }
        })
      } else {
        next()
      }
    } else {
      // 正常token 逻辑
      if(stage.token){
      	next();
      }
      else if (getToken() != null) {
        store.dispatch('user/getPreference').then(()=>{
          if (store.getters['user/userRoles'].length === 0) {
            // 获取userInfo 每次刷新都会走
            store.dispatch('user/getInfo').then(response => {
              stage.time.timeZoneCode = response.organization.timezone
              stage.time.timeZone = mz.tz(response.organization.timezone).format('Z') // 时区转成可读小时分
              stage.time.offset = mz.tz(response.organization.timezone)._offset * 60 * 1000 // 时区转成毫秒
              let { orgUser: {roleId} } = response
              store.dispatch('user/GetRoles', { 'type': 'GET_USER_ROLES', roleId }).then(response => {
                let {codeList, dataScopeList} = response
                let auth = codeList.filter(_ => _.isOn !== 0).map(_ => _.code)
                let buttonPermissions = JSON.parse(localStorage.getItem('buttonPermissions')) || []
                let scopePermissions = JSON.parse(localStorage.getItem('scopePermissions')) || []
                let isLogin = (_.isEqual(auth, buttonPermissions)) && (_.isEqual(dataScopeList, scopePermissions))
                if (!isLogin) {
                  Notify.init(translate('401'))// 跳转前给出提示
                  removeToken()
                  removeRefreshToken()
                  next('/login')
                } else {
                  canTo(to, from, next)
                }
              },
              error => Notify.init(translate(error))
              )
            }, error => {
              let { status } = error.response
              if (status === 401) {
                console.log('access_token 调取失败')
                // 失败的话重新用refresh_token 刷新 access_token
                getRefreshToken('/oauth/token', {
                  grant_type: 'refresh_token',
                  client_id: 'test',
                  refresh_token: authUtils.getRefreshToken()
                }).then(response => {
                  let { access_token, refresh_token } = response
                  authUtils.setToken(access_token)
                  authUtils.setRefreshToken(refresh_token)
  
                  // 拿取新的accessToken 登录 刷新一下
                  setTimeout(() => {
                    location.reload()
                  }, 50)
                  canTo(to, from, next)
                }, error => {
                  console.log('error' + error)
                  // 重新登录
                  next('/login')
                })
              }
            })
          } else {
            canTo(to, from, next)
          }
        })
        // if (to.path === '/login') {
        // 	next({ path: localStorage.getItem('directPath')})
        // }
        // 刷新导致缺失
        
      } else {
        if (whiteList.indexOf(to.path) !== -1) {
          canTo(to, from, next)
        } else {
          if (to.path.indexOf('/sim') > -1) {
            canTo(to, from, next)
          } else {
            next('/login')
          }
        }
      }
    }
    /// *
    //* /
  }
  setTimeout(() => {
    $('svg title').remove()// 处理掉svg文件里的title
    $("[stroke='#000']").removeAttr('stroke')// 去除黑色描边，用于可class定义
  }, 1000)
  // trace(to.path)
})

// 路由结束操作
router.afterEach(() => {
})



// WEBPACK FOOTER //
// ./src/permission.js